import React from "react"
import { useSelector } from "react-redux"

import { selectScopedByClient } from "../../stores/appSlice"
import GroupAccountTable from "./components/GroupAccountTable"
import GroupAccountForm from "./components/GroupAccountForm"
import SubaccountTable from "./components/SubaccountTable"
import BillTable from "../bills/components/BillTable"
import DashboardPlaceholder from "../../components/utilityComponents/placeholders/DashboardPlaceholder"

export default function GroupAccountPage({ view, recordSelected }) {
    const scopedByClient = useSelector(selectScopedByClient)

    const renderView = () => {
        switch (view) {
            case "dashboard":
                return renderDashboard()
            case "index":
                return renderIndex()
            case "form":
                return renderForm()
            case "bills":
                return renderBills()
            case "subaccounts":
                return renderSubaccounts()
            default:
                return renderIndex()
        }
    }

    const renderDashboard = () => {
        if (!scopedByClient) {
            return null
        }

        return <DashboardPlaceholder />
    }

    const renderIndex = () => {
        if (scopedByClient) {
            return <GroupAccountTable scopedByClient={scopedByClient} />
        }

        return <GroupAccountTable scopedByClient={scopedByClient} />
    }

    const renderForm = () => {
        return (
            <>
                <h1>Manage Group Account</h1>
                <GroupAccountForm actionName="new" />
            </>
        )
    }

    const renderBills = () => {
        return <BillTable scopedByClient={scopedByClient} />
    }

    const renderSubaccounts = () => {
        return <SubaccountTable scopedByClient={scopedByClient} />
    }

    return <>{renderView()}</>
}
